import _extends from 'babel-runtime/helpers/extends';
import findIndex from 'lodash/findIndex';
import get from 'lodash/get';

export var SET_AB_DATA = 'SET_AB_DATA';
export var CLEAR_AB_DATA = 'CLEAR_AB_DATA';
export var FEATURE_FLAGS_RECEIVED = 'FEATURE_FLAGS_RECEIVED';

export var abReducer = function abReducer() {
  var _extends2;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case SET_AB_DATA:
      return _extends((_extends2 = {}, _extends2[action.payload.abKey] = action.payload.data, _extends2), state);
    case CLEAR_AB_DATA:
      {
        var newState = _extends({}, state);
        delete newState[action.payload.abKey];
        return newState;
      }
    case FEATURE_FLAGS_RECEIVED:
      {
        var _newState = _extends({}, state);
        _newState.featureFlags = action.payload.featureFlags;
        return _newState;
      }
    default:
      return state;
  }
};

export var abActions = {
  setAbData: function setAbData(abKey, data) {
    return {
      type: SET_AB_DATA,
      payload: {
        abKey: abKey,
        data: data
      }
    };
  },
  clearAbData: function clearAbData(abKey, data) {
    return {
      type: CLEAR_AB_DATA,
      payload: {
        abKey: abKey,
        data: data
      }
    };
  },
  featureFlagsReceived: function featureFlagsReceived(featureFlags) {
    return {
      type: FEATURE_FLAGS_RECEIVED,
      payload: {
        featureFlags: featureFlags
      }
    };
  }
};

export var abSelectors = {
  getAbData: function getAbData(state) {
    return state.ab;
  },
  getAbKeyData: function getAbKeyData(state, abKey) {
    return get(state, ['ab', abKey]);
  },
  isFeatureEnabled: function isFeatureEnabled(state, feature) {
    return findIndex(state.ab.featureFlags, function (flag) {
      return flag.toLowerCase() === feature.toLowerCase();
    }) !== -1;
  }
};